import React, { useEffect, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./ListNotes.style";
import ZaiaSelect from "../../../../zaiaComponents/zaiaSelect";
import { useQuery } from "@apollo/client";
import { QUERY_GET_PROCESS_NAMES } from "../../../../../graphql/queries/Process";

import * as P from "../../../../../utils/pipes";
import Popup from "reactjs-popup";
import Modal from "../../../../../utils/modal";
import ModalSelectPatient from "../../../shared/modals/modalSelectPatient";

function ListNotes({
  listNotes=[],
  maxViewActived,
  setNoteSelected,
  setCreateNoteActived,
  setEditNoteActived,
  patientSelected,
  historyActived,
  setHistoryActived,
  noteHistorySelected,
  setNoteHistorySelected,
  setPatientSelected,
  patientSelectionActived,
  setPatientSelectionActived
}) {

  const {t, i18n: { language }} = useTranslation("global");

  console.log("LAMPPPP", listNotes);
  

  return (
    <S.ListNotes
      maxViewActived={maxViewActived}
    >
      { 
        <Modal open={patientSelectionActived}>
          <ModalSelectPatient
            setModalActive={setPatientSelectionActived}
            setPatient={setPatientSelected}
          />
        </Modal>
      }
      <button className="button-patient-selector"
        onClick={() => setPatientSelectionActived(true)}
      >
        <div className="button-patient-selector__icon-container">
          {
            patientSelected 
            ? <img
              src={patientSelected.picture}
              alt={patientSelected?.name || t("notes.selectPatientStart")}
              className="button-patient-selector__img"
            />
            : <i className="button-patient-selector__icon icon zaia-i-person"></i>
          }
        </div> 
        <div className="button-patient-selector__text">
          {
            patientSelected
            ? `${patientSelected.name} ${patientSelected.lastname}`
            : t("notes.selectPatientStart")
          }
        </div>
      </button>
      <div className="list-notes">
        {
          listNotes?.map(note => {
            return (
              <Note
                key={note.id}
                note={note}
                setNoteSelected={setNoteSelected}
                setEditNoteActived={setEditNoteActived}
                setHistoryActived={setHistoryActived}
                setNoteHistorySelected={setNoteHistorySelected}
              />
            )
          })
        }
      </div>
    </S.ListNotes>
  );
}

const Note = ({
  note,
  setNoteSelected,
  setEditNoteActived,
  setHistoryActived,
  setNoteHistorySelected
}) => {

  const {t, i18n: { language }} = useTranslation("global");  

  console.log("NOTE", note);
  

  return (
    <div className="note-card"
      onClick={() => {
        setEditNoteActived(null)
        setHistoryActived(null)
        setNoteSelected(note)
        setNoteHistorySelected(null)
      }
      }
    >
      <div className="note-card__header">
        <div className="note-card__date">
          <div className="note-card__date-date">
            {P.longDate(note.created_at, t, language)}
          </div>
          <div className="note-card__date-time">
            {P.hoursIn12format(new Date(note.created_at).getHours(), new Date(note.created_at).getMinutes(), t, language)}
          </div>
        </div>
        <Popup
          trigger={
            <div className="note-card__option">
              <i className="note-card__option-icon icon zaia-icono-dots-horizontal"></i>
            </div>
          }
          keepTooltipInside
          nested
          // position={"right bottom"}
        >
          {
            close => (
              <S.CardOptions>
                <div className="card-option"
                  onClick={() => {setEditNoteActived(note)}}
                >
                  <div className="card-option__icon">
                    <i className="icon zaia-icono-editar"/>
                  </div>
                  <div className="card-option__text">
                    {t("globally.edit")}
                  </div>
                </div>
                {/* <div className="card-option">
                  <div className="card-option__icon">
                    <i className="icon zaia-i-trash-can"/>
                  </div>
                  <div className="card-option__text">
                    {t("globally.delete")}
                  </div>
                </div> */}
                
                {/* <div className="card-option"
                  onClick={() => {
                    setNoteHistorySelected(null);
                    setHistoryActived(note);
                    close();
                  }}
                >
                  <div className="card-option__icon">
                    <i className="icon zaia-i-reverse-clocl"/>
                  </div>
                  <div className="card-option__text">
                    {t("globally.history")}
                  </div>
                </div> */}

              </S.CardOptions>
            )
          }
        </Popup>
      </div>
      {
        note?.title &&
        <div className="note-card__title">
          {note?.title}
        </div>
      }
      <div className="note-card__note">
        {
          note?.transductionTemplated?.split(" ").length > 10
          ? `${note?.transductionTemplated?.split(" ").slice(0, 7).join(" ")}... `
          : note?.transductionTemplated
        } <b className="expand-comment">{
          note?.transductionTemplated?.split(" ").length > 10 && t("globally.readMore")
        }</b>
      </div>
    </div>
  );

}

export default ListNotes;
